// document.addEventListener("DOMContentLoaded", function () {

//   const showMoreBtn = document.getElementById("yas_showmre");

//   if (!showMoreBtn) return;

//   const descriptionWrapper = document.querySelector(
//     ".product-info__description .prose"
//   );

//   if (!descriptionWrapper) return;

//   const collapsedHeight = 160;

//   // Collapse initially
//   if (descriptionWrapper.scrollHeight > collapsedHeight) {
//     descriptionWrapper.style.maxHeight = collapsedHeight + "px";
//     descriptionWrapper.style.overflow = "hidden";
//     descriptionWrapper.style.position = "relative";
//   } else {
//     // Hide button if content small
//     showMoreBtn.style.display = "none";
//   }

// });


// // Global function (called from onclick)
// function yas_showmre() {

//   const showMoreBtn = document.getElementById("yas_showmre");

//   const descriptionWrapper = document.querySelector(
//     ".product-info__description .prose"
//   );

//   if (!showMoreBtn || !descriptionWrapper) return;

//   const collapsedHeight = 160;

//   const readMoreText = showMoreBtn.getAttribute("data-readt");
//   const readLessText = showMoreBtn.getAttribute("data-lesst");

//   if (descriptionWrapper.style.maxHeight === collapsedHeight + "px") {

//     // Expand
//     descriptionWrapper.style.maxHeight =
//       descriptionWrapper.scrollHeight + "px";

//     showMoreBtn.innerHTML = readLessText;

//     showMoreBtn.classList.add("less_content");

//   } else {

//     // Collapse
//     descriptionWrapper.style.maxHeight =
//       collapsedHeight + "px";

//     showMoreBtn.innerHTML = readMoreText;

//     showMoreBtn.classList.remove("less_content");

//   }

// }

document.addEventListener("DOMContentLoaded", function () {

  const collapsedHeight = 150;

  document.querySelectorAll(".product-info__description").forEach(function(wrapper){

    const descriptionWrapper = wrapper.querySelector(".prose");
    const showMoreBtn = wrapper.querySelector(".read-button");

    if (!descriptionWrapper || !showMoreBtn) return;

    if (descriptionWrapper.scrollHeight > collapsedHeight) {
      descriptionWrapper.style.maxHeight = collapsedHeight + "px";
      descriptionWrapper.style.overflow = "hidden";
      descriptionWrapper.style.position = "relative";
    } else {
      showMoreBtn.style.display = "none";
    }

    showMoreBtn.addEventListener("click", function(){

      const readMoreText = showMoreBtn.dataset.readt;
      const readLessText = showMoreBtn.dataset.lesst;

      if (descriptionWrapper.style.maxHeight === collapsedHeight + "px") {

        descriptionWrapper.style.maxHeight =
          descriptionWrapper.scrollHeight + "px";

        showMoreBtn.innerHTML = readLessText;
        showMoreBtn.classList.add("less_content");

      } else {

        descriptionWrapper.style.maxHeight =
          collapsedHeight + "px";

        showMoreBtn.innerHTML = readMoreText;
        showMoreBtn.classList.remove("less_content");

      }

    });

  });

});